/**
 * What a SvelteKit 3 `handleError` hook was handed, read the way production
 * hands it: `{ kind, error }`, with no `status` or `message` (Kit adds those
 * only in dev, as deprecated getters). Shared by hooks.server.js and
 * hooks.client.js so both filter the same way.
 *
 * - `unknown`: our code threw. Always a failure; Kit answers 500 "Internal Error".
 * - `framework`: Kit's own (no route matched, method not allowed, ...).
 * - `app`: an `error(status, message)` we threw on purpose. Kit 2 never passed
 *   these to the hook; Kit 3 does.
 *
 * Only `unknown` and anything >= 500 is reported. A 404 is noise - scanners
 * probing /.env and friends, or a wrong secret on /internal and /api/health -
 * and so are framework 4xx: GLORB's hook recorded 24 `405`s in 30 days from
 * bots POSTing to the homepage, which hub rule R003 says is not a person.
 *
 * @param {{ kind?: string, error?: any }} caught
 * @returns {{ status: number, message: string, report: boolean }}
 */
export function describeCaughtError({ kind, error } = {}) {
  if (kind === "app" || kind === "framework" || kind === "validation") {
    const status = Number(error?.status) || 500;
    return { status, message: error?.message ?? "", report: status >= 500 };
  }
  return { status: 500, message: "Internal Error", report: true };
}
